<template>

<app-text>

    <template v-if="!is.verifying && !is.calculating">

        <app-group v-html="page.business_adverts_book_payment_content" />

        <div class="payment-stats">

            <div class="payment-stats-item">

                <div class="payment-stats-item-value">£{{ payment.cost }}</div>
                <div class="payment-stats-item-title">{{ page.business_adverts_book_payment_cost }}</div>

            </div>

            <div class="payment-stats-item">

                <div class="payment-stats-item-value">{{ payment.points }}</div>
                <div class="payment-stats-item-title">{{ page.business_adverts_book_payment_points }}</div>

            </div>

            <div class="payment-stats-item">

                <div class="payment-stats-item-value">{{ payment.available }}</div>
                <div class="payment-stats-item-title">{{ page.business_adverts_book_payment_available }}</div>

            </div>

        </div>

        <app-group :row="true" :center="true">

            <com-stripe ref="stripe" mode="payment" :customerEmail="stripe.email" :pk="stripe.key" :lineItems="stripe.items" :successUrl="stripe.success" :cancelUrl="stripe.cancel">

                <template slot="checkout-button">

                    <app-button :fixed="true" :text="page.business_adverts_book_payment_button_pay" :loading="is.loading" v-on:click="onPaymentClick" />

                </template>

            </com-stripe>

            <app-button :fixed="true" :disabled="payment.points > payment.available" :loading="is.loading" :text="page.business_adverts_book_payment_button_points" v-on:click="onPointsClick" />
            <app-button :text="page.business_adverts_book_payment_button_cancel" theme="plain" v-on:click="$emit('back')" />

        </app-group>

    </template>
    
    <div class="payment-verifying" v-if="is.verifying || is.calculating"></div>

</app-text>

</template>

<script>

import { StripeCheckout } from 'vue-stripe-checkout'

export default {

	components: {
		'com-stripe': StripeCheckout
    },

    props: ['duration', 'inputs'],

    data: function() {

        return {
            is: {
                verifying: false,
                calculating: false
            },
            stripe: {
                key: '',
                email: '',
				items: [],
				success: '',
				cancel: ''
            },
            payment: {
                cost: 0,
                points: 0,
                available: 0
            }
        }

    },

    watch: {

        duration: function() {

            this.calculatePayment()

        }

    },

    created: function() {

        if (this.$route.meta.cancel) {
            
            this.calculatePayment()

        } else if(this.$route.meta.success) {

            this.completeBooking({
                stripe: this.$route.query.key
            })

        }

    },
    
    methods: {

        calculatePayment: function() {

            this.is.calculating = true

            this.$api.request('account/advverts/calculate', {
                duration: this.duration
            }).then(function(json) {

                this.stripe.key = json.key

                this.stripe.email = json.email

                this.stripe.items = []

                this.stripe.items.push({
                    price: json.price,
                    quantity: 1
                })

                this.stripe.success = json.success
                this.stripe.cancel = json.cancel

                this.payment.cost = json.cost
                this.payment.points = json.points 
                this.payment.available = json.available

                this.is.calculating = false

            }.bind(this))

        },

        completeBooking: function(data) {

            data = data || {}

            data.inputs = this.inputs

            this.is.verifying = true 

            this.$api.request('account/advverts/create', data).then(function() {

                this.$store.commit('memory/delete', 'adverts/book');

                this.$router.replace({
                    name: 'Account/Adverts'
                })

                this.$emit('proceed')

            }.bind(this), function() {

                this.is.verifying = false 
                this.is.calculating = false 

                this.$router.replace({
                    name: 'Account/Adverts'
                })

            }.bind(this))

        },

        onPointsClick: function() {

			this.is.loading = true

            this.completeBooking({
                points: this.payment.points
            })

        },

        onPaymentClick: function() {

			this.is.loading = true

			this.$refs.stripe.redirectToCheckout()

		}

    }
    
}

</script>

<style scoped>

.payment-verifying {
    height: 200px;
    background-image: url(~@/assets/app.load.gif);
    background-position: 50% 50%;
    background-repeat: no-repeat;
}

.payment-stats {
    display: flex;
    flex-direction: row;
    border: 1px solid var(--color-grey-light);
    border-radius: 4px;
    margin-bottom: 20px;
}

.is-mobile .payment-stats {
    flex-direction: column;
}

.payment-stats-item {
    width: 33.3%;
    padding: 20px;
    text-align: center;
    border-left: 1px solid var(--color-grey-light);
}

.is-mobile .payment-stats-item {
    width: 100%;
    padding: 10px;
    border-left: 0px;
    border-top: 1px solid var(--color-grey-light);
}

.payment-stats-item:first-child {
    border-left-width: 0px;
}

.is-mobile .payment-stats-item:first-child {
    border-left-width: 1px;
    border-top-width: 0px;
}

.payment-stats-item-value {
    font-size: 32px;
    font-weight: 700;
    color: var(--color-grey-dark);
}

.payment-stats-item-title {
    font-size: 14px;
    font-weight: 400;
    margin-top: 4px;
    color: var(--color-grey-dark);
}

</style>